import { useQuery } from "@tanstack/react-query";
import { ThemeRepositoryImpl } from "../../data/repository/theme_repository_impl";
import { ThemeInterface } from "../interface/theme_interface";
import { AxiosError } from "axios";

export const useGetThemeByCompanyId = (companyId?: string) => {
  const repository = new ThemeRepositoryImpl();

  return useQuery<ThemeInterface[] | null, AxiosError>({
    queryKey: ["themeByCompanyId", companyId],
    queryFn: () => repository.getThemeByCompanyId(companyId!),
    enabled: !!companyId,
  });
}

export const useGetThemeById = (themeId?: string) => {
  const repository = new ThemeRepositoryImpl();

  return useQuery<ThemeInterface | null, AxiosError>({
    queryKey: ["themeById", themeId],
    queryFn: () => repository.getThemeById(themeId!),
    enabled: !!themeId,
  });
}
